var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.504 2.032H7.017L5.724 3.325v6.767l1.293 1.293h4.487l1.293-1.293V3.325l-1.293-1.293ZM6.724 3.74l.707-.707h3.659l.707.707v5.94l-.707.706H7.43l-.707-.707V3.74Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.875 5.421-.672.865v5.975l.707.707h3.694l.865-.672.613.79-1.135.882H4.496l-1.293-1.293V5.943l.882-1.135.79.613Z",
    fill: "currentColor"
  })));
};
export default SvgCopy;